import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const CheckIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0.525513 7.28571L6.34369 13L16.5255 3" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

CheckIcon.displayName = 'CheckIcon';
